/**
 * DropPage's document meta — mirrors the edge worker's tag precedence for
 * /drop-in/:slug (cloudflare-workers/devourplay-seo) so JS-executing crawlers
 * and the browser tab agree with what the worker serves UA-sniffed crawlers:
 * admin-authored seo fields first, then the Drop's display fields. The
 * canonical always points at /drop-in/:slug — vanity URLs (/:handle) render
 * the same component, so they self-declare the drop-in URL as canonical
 * instead of competing with it in the index.
 */
import type {Drop} from "@/hooks/drop/useGetDrop";

export function dropPageMeta(drop: Drop, slug: string | undefined) {
    const metaTitle = drop.seo?.title || `${drop.name} — Drop-In | DevourPlay`;
    const metaDescription = drop.seo?.description ||
        drop.description ||
        `Follow ${drop.name} on DevourPlay — watch live streams, join challenges, and earn rewards.`;
    const metaImage = drop.seo?.socialShareImageUrl ||
        drop.creatorHeaderImageUrl ||
        drop.creatorProfileImageUrl ||
        "https://cdn.devourplay.gg/images/devourplay-og-image.png";
    const canonicalUrl = drop.seo?.canonicalUrl || `https://devourplay.gg/drop-in/${drop.slug || slug}`;

    return {metaTitle, metaDescription, metaImage, canonicalUrl};
}
